import { Components, Theme } from '@mui/material';

export const iconButtonStyles: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: {
      padding: '6px',
      borderRadius: 0,
      '& .MuiSvgIcon-root': {
        width: '20px',
        height: '20px'
      }
    }
  }
};
